import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { AggregatorHttpGetService } from '../../Services/AggregatorHttpConfig';
import { IEstelamForeignNationalityQuery, IEstelamSabtAhvalQuery } from '../../Types/Queries/IEstelamSabtAhvalQuery';

export const estelamSabtAhvalThunk = createAsyncThunk(
  'Aggregator/estelamSabtAhval',
  async (query: IEstelamSabtAhvalQuery) => {
    return await AggregatorHttpGetService({
      url: `${_apiPathManagerConfig?.Aggregator.SabtAhval.EstelamSabtAhval}`,
      params: query,
    });
  }
);

export const estelamForeignNationalityThunk = createAsyncThunk(
  'Aggregator/EstelamForeignNationality',
  async (query: IEstelamForeignNationalityQuery) => {
    return await AggregatorHttpGetService({
      url: `${_apiPathManagerConfig?.Aggregator.SabtAhval.EstelamForeignNationality}`,
      params: query,
    });
  }
);
